// import React from "react";
// import api from "../api";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   CartesianGrid,
// } from "recharts";
// import MobileConnectQR from '../components/MobileConnectQR';

// export default function Dashboard() {
//   const [revenue, setRevenue] = React.useState({
//     daily: 0,
//     weekly: 0,
//     monthly: 0,
//     yearly: 0,
//     total: 0,
//   });
//   const [tops, setTops] = React.useState([]);
//   const [lowStock, setLowStock] = React.useState({ ingredients: [], menuItems: [] });
//   const [loading, setLoading] = React.useState(true);
//   const [tableQRCodes, setTableQRCodes] = React.useState([]);
//   const [backups, setBackups] = React.useState([]);

//   // ✅ Detect Cloudflare URL
//   const cloudflareBase = window.location.hostname.includes("trycloudflare.com")
//     ? window.location.origin
//     : null;

//   async function loadTableQRCodes() {
//     try {
//       const res = await api.get("/tables/qrcodes");
//       let data = res.data || [];

    

//       setTableQRCodes(data);
//     } catch (err) {
//       console.error("Failed to load table QRs", err);
//     }
//   }

//   async function syncOfflineStock() {
//   if (!navigator.onLine) return;

//   const logs = await api.get("/offline/unsynced-stock");
//   if (!logs.data.length) return;

//   await api.post("/offline/sync-stock", { logs: logs.data });

//   console.log("✅ Offline stock synced!");
// }

// setInterval(syncOfflineStock, 8000);
// window.addEventListener("online", syncOfflineStock);


//   React.useEffect(() => {
//     load();
//     loadBackups();
//     loadTableQRCodes();
//   }, []);



//   async function loadBackups() {
//   try {
//     const res = await api.get("/backup/list");
//     setBackups(res.data.backups || []);
//   } catch (err) {
//     console.warn("Cannot load backups (offline or server down)");
//     setBackups([]); // fallback so component renders the "No backups" message
//   }
// }

// async function handleCreateBackup() {
//   if (!window.confirm("🧩 Create a new backup now?")) return;
//   try {
//     const res = await api.post("/backup/create");
//     const name = res.data.backup?.name || res.data.file || "backup";
//     alert("✅ Backup created: " + name);
//     await loadBackups();
//   } catch (err) {
//     console.error("Backup creation failed:", err);
//     alert("❌ Backup failed");
//   }
// }

// async function handleRestoreBackup(name) {
//   if (!window.confirm(`⚠️ This will restore backup '${name}'. Continue?`)) return;
//   try {
//     const res = await api.post("/backup/restore", { name }); // ✅ backend expects { name }
//     if (res.data.success) {
//       alert(res.data.message || "✅ Database restored successfully!");
//       await loadBackups();
//     } else {
//       alert("⚠️ Restore returned an unexpected response");
//     }
//   } catch (err) {
//     console.error("Restore failed:", err);
//     alert("❌ Restore failed!");
//   }
// }


//   async function load() {
//     try {
//       const [r, t, l] = await Promise.all([
//         api.get("/analytics/revenue"),
//         api.get("/analytics/top-items"),
//         api.get("/analytics/low-stock"),
//       ]);
//       setRevenue(r.data || {});
//       setTops(t.data || []);

//       if (l.data.ingredients !== undefined) {
//         setLowStock(l.data);
//       } else {
//         setLowStock({ ingredients: [], menuItems: l.data || [] });
//       }
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   }

//   if (loading) {
//     return (
//       <div className="p-6 text-center text-gray-500">Loading Dashboard...</div>
//     );
//   }

//   const hasLowStock = lowStock.ingredients.length > 0 || lowStock.menuItems.length > 0;

//   return (
//     <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
//       <h2 className="text-3xl font-bold text-center mb-6">📊 Dashboard</h2>

//       {hasLowStock && (
//         <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg shadow">
//           <h3 className="font-bold text-red-700 mb-3 text-lg">⚠️ Low Stock Alert!</h3>

//           {lowStock.ingredients.length > 0 && (
//             <div className="mb-3">
//               <h4 className="font-semibold text-red-600 mb-2">Ingredients:</h4>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
//                 {lowStock.ingredients.map(i => (
//                   <div key={i._id} className="text-sm text-red-600 bg-white p-2 rounded">
//                     • {i.name}: <span className="font-semibold">{i.quantity} {i.unit}</span>
//                     <span className="text-xs text-gray-600"> (Min: {i.minThreshold} {i.unit})</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {lowStock.menuItems.length > 0 && (
//             <div>
//               <h4 className="font-semibold text-red-600 mb-2">Menu Items:</h4>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
//                 {lowStock.menuItems.map(i => (
//                   <div key={i._id} className="text-sm text-red-600 bg-white p-2 rounded">
//                     • {i.name}: <span className="font-semibold">{i.stock || 0} units</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
//         <RevenueCard title="Today" value={revenue.daily} />
//         <RevenueCard title="This Week" value={revenue.weekly} />
//         <RevenueCard title="This Month" value={revenue.monthly} />
//         <RevenueCard title="This Year" value={revenue.yearly} />
//         <RevenueCard title="Total Revenue" value={revenue.total} highlight />
//       </div>

//       <div className="dashboard-section">
//         <MobileConnectQR />
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//         <div className="bg-white rounded-2xl p-6 shadow">
//           <h3 className="text-lg font-bold mb-4 text-gray-700">
//             🍽️ Top Selling Items
//           </h3>

//           {tops.length === 0 ? (
//             <div className="text-gray-500 text-sm">No data available</div>
//           ) : (
//             <>
//               <ul className="space-y-1 mb-4">
//                 {tops.slice(0, 5).map((t, i) => (
//                   <li key={i} className="flex justify-between border-b py-1">
//                     <span>{t.name}</span>
//                     <span className="font-semibold">{t.qty}</span>
//                   </li>
//                 ))}
//               </ul>

//               <div className="w-full h-48">
//                 <ResponsiveContainer>
//                   <BarChart data={tops.slice(0, 10)}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="name" />
//                     <YAxis />
//                     <Tooltip />
//                     <Bar dataKey="qty" fill="#82ca9d" />
//                   </BarChart>
//                 </ResponsiveContainer>
//               </div>
//             </>
//           )}
//         </div>

//         <div className="bg-white rounded-2xl p-6 shadow">
//           <h3 className="text-lg font-bold mb-4 text-gray-700">
//             📦 Inventory Status
//           </h3>
//           {!hasLowStock ? (
//             <div className="text-gray-500 text-sm">
//               ✅ All items sufficiently stocked
//             </div>
//           ) : (
//             <div>
//               {lowStock.ingredients.length > 0 && (
//                 <div className="mb-4">
//                   <h4 className="font-semibold text-sm text-gray-600 mb-2">
//                     Low Stock Ingredients ({lowStock.ingredients.length})
//                   </h4>
//                   <ul className="space-y-1">
//                     {lowStock.ingredients.slice(0, 5).map((i) => (
//                       <li key={i._id} className="flex justify-between border-b py-1">
//                         <span className="text-sm">{i.name}</span>
//                         <span className="font-semibold text-red-500 text-sm">
//                           {i.quantity} {i.unit}
//                         </span>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               )}

//               {lowStock.menuItems.length > 0 && (
//                 <div>
//                   <h4 className="font-semibold text-sm text-gray-600 mb-2">
//                     Low Stock Menu Items ({lowStock.menuItems.length})
//                   </h4>
//                   <ul className="space-y-1">
//                     {lowStock.menuItems.slice(0, 5).map((i) => (
//                       <li key={i._id} className="flex justify-between border-b py-1">
//                         <span className="text-sm">{i.name}</span>
//                         <span className="font-semibold text-red-500 text-sm">
//                           {i.stock || 0}
//                         </span>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ✅ Table QR Codes */}
//       <div className="bg-white rounded-2xl p-6 shadow">
//         <h3 className="text-lg font-bold mb-4 text-gray-700">🧾 Table QR Codes</h3>

//         {tableQRCodes.length === 0 ? (
//           <div className="text-gray-500 text-sm">No tables found.</div>
//         ) : (
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//             {tableQRCodes.map((table, i) => (
//               <div key={i} className="p-3 border rounded-lg shadow-sm text-center">
//                 <h4 className="font-semibold text-gray-700 mb-2">{table.table}</h4>
//                 <img
//                   src={table.qrCode}
//                   alt={`QR for ${table.table}`}
//                   className="mx-auto w-32 h-32"
//                 />
//                 <p className="text-xs text-gray-500 mt-2 break-all">{table.url}</p>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Backup Section */}
//       <div className="bg-white rounded-2xl p-6 shadow">
//         <h3 className="text-lg font-bold mb-4 text-gray-700">💾 Database Backup Manager</h3>

//         <div className="flex gap-3 mb-4">
//           <button
//             onClick={handleCreateBackup}
//             className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
//           >
//             📦 Create Backup
//           </button>
//           <button
//             onClick={loadBackups}
//             className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 transition"
//           >
//             🔄 Refresh List
//           </button>
//         </div>

//         {backups.length === 0 ? (
//           <div className="text-gray-500">No backups found.</div>
//         ) : (
//           <ul className="divide-y divide-gray-200">
//             {backups.map((b, i) => (
//               <li key={i} className="flex justify-between items-center py-2">
//                 <span className="text-sm text-gray-700">
//                   {b.name}
//                 <span className="text-xs text-gray-500">
//                   {b.createdAt ? ` (${new Date(b.createdAt).toLocaleString()})` : ""}
//                 </span>

//                 </span>
//                 <button
//                   onClick={() => handleRestoreBackup(b.name)}
//                   className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition"
//                 >
//                   🔁 Restore
//                 </button>
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>
//     </div>
//   );
// }

// function RevenueCard({ title, value, highlight }) {
//   return (
//     <div
//       className={`p-4 rounded-xl shadow text-center transition ${
//         highlight ? "bg-green-100 border border-green-300" : "bg-white"
//       }`}
//     >
//       <div className="text-gray-600 text-sm">{title}</div>
//       <div className="text-xl font-bold text-green-700">
//         ₹ {Number(value || 0).toFixed(2)}
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import api from "../api";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import MobileConnectQR from '../components/MobileConnectQR';

export default function Dashboard() {
  const [revenue, setRevenue] = useState({ daily:0, weekly:0, monthly:0, yearly:0, total:0 });
  const [tops, setTops] = useState([]);
  const [lowStock, setLowStock] = useState({ ingredients: [], menuItems: [] });
  const [loading, setLoading] = useState(true);
  const [tableQRCodes, setTableQRCodes] = useState([]);
  const [backups, setBackups] = useState([]);

  // ---------------- Load data ----------------
  const loadAnalytics = async () => {
    try {
      const [r, t, l] = await Promise.all([
        api.get("/analytics/revenue"),
        api.get("/analytics/top-items"),
        api.get("/analytics/low-stock"),
      ]);
      setRevenue(r.data || {});
      setTops(t.data || []);
      if(l.data.ingredients !== undefined) setLowStock(l.data);
      else setLowStock({ ingredients: [], menuItems: l.data || [] });
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const loadTableQRCodes = async () => {
    try { setTableQRCodes((await api.get("/tables/qrcodes")).data || []); }
    catch (err) { console.error("Failed to load table QRs:", err); }
  };

  const loadBackups = async () => {
    try { setBackups((await api.get("/backup/list")).data.backups || []); }
    catch (err) { setBackups([]); }
  };

  const syncOfflineStock = async () => {
    if (!navigator.onLine) return;
    try {
      const logs = await api.get("/offline/unsynced-stock");
      if (!logs.data.length) return;
      await api.post("/offline/sync-stock", { logs: logs.data });
      console.log("✅ Offline stock synced!");
    } catch (err) { console.error("Offline sync failed:", err); }
  };

  useEffect(() => {
    loadAnalytics();
    loadTableQRCodes();
    loadBackups();

    const interval = setInterval(syncOfflineStock, 8000);
    window.addEventListener("online", syncOfflineStock);

    return () => {
      clearInterval(interval);
      window.removeEventListener("online", syncOfflineStock);
    };
  }, []);

  // ---------------- Backup handlers ----------------
  const handleCreateBackup = async () => {
    if(!window.confirm("🧩 Create a new backup now?")) return;
    try {
      const res = await api.post("/backup/create");
      const name = res.data.backup?.name || res.data.file || "backup";
      alert("✅ Backup created: "+name);
      loadBackups();
    } catch (err) { alert("❌ Backup failed"); console.error(err); }
  };

  const handleRestoreBackup = async (name) => {
    if(!window.confirm(`⚠️ This will restore backup '${name}'. Continue?`)) return;
    try {
      const res = await api.post("/backup/restore", { name });
      if(res.data.success) { alert(res.data.message || "✅ Restored successfully!"); loadBackups(); }
      else alert("⚠️ Restore returned unexpected response");
    } catch(err) { alert("❌ Restore failed!"); console.error(err); }
  };

  if(loading) return <div className="p-6 text-center text-gray-500">Loading Dashboard...</div>;

  const hasLowStock = lowStock.ingredients.length > 0 || lowStock.menuItems.length > 0;

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      <h2 className="text-3xl font-bold text-center mb-6">📊 Dashboard</h2>

      {hasLowStock && (
        <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg shadow">
          <h3 className="font-bold text-red-700 mb-3 text-lg">⚠️ Low Stock Alert!</h3>
          {lowStock.ingredients.length > 0 && (
            <div className="mb-3">
              <h4 className="font-semibold text-red-600 mb-2">Ingredients:</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {lowStock.ingredients.map(i => (
                  <div key={i._id} className="text-sm text-red-600 bg-white p-2 rounded">
                    • {i.name}: <span className="font-semibold">{i.quantity} {i.unit}</span>
                    <span className="text-xs text-gray-600"> (Min: {i.minThreshold} {i.unit})</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {lowStock.menuItems.length > 0 && (
            <div>
              <h4 className="font-semibold text-red-600 mb-2">Menu Items:</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {lowStock.menuItems.map(i => (
                  <div key={i._id} className="text-sm text-red-600 bg-white p-2 rounded">
                    • {i.name}: <span className="font-semibold">{i.stock || 0} units</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <RevenueCard title="Today" value={revenue.daily} />
        <RevenueCard title="This Week" value={revenue.weekly} />
        <RevenueCard title="This Month" value={revenue.monthly} />
        <RevenueCard title="This Year" value={revenue.yearly} />
        <RevenueCard title="Total Revenue" value={revenue.total} highlight />
      </div>

      <MobileConnectQR />

      {/* Top Selling Items */}
      <div className="bg-white rounded-2xl p-6 shadow">
        <h3 className="text-lg font-bold mb-4 text-gray-700">🍽️ Top Selling Items</h3>
        {tops.length === 0 ? (
          <div className="text-gray-500 text-sm">No data available</div>
        ) : (
          <>
            <ul className="space-y-1 mb-4">
              {tops.slice(0,5).map((t,i)=>(
                <li key={i} className="flex justify-between border-b py-1">
                  <span>{t.name}</span>
                  <span className="font-semibold">{t.qty}</span>
                </li>
              ))}
            </ul>
            <div className="w-full h-48">
              <ResponsiveContainer>
                <BarChart data={tops.slice(0,10)}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="qty" fill="#82ca9d" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </>
        )}
      </div>

      {/* Inventory */}
      <div className="bg-white rounded-2xl p-6 shadow">
        <h3 className="text-lg font-bold mb-4 text-gray-700">📦 Inventory Status</h3>
        {!hasLowStock ? (
          <div className="text-gray-500 text-sm">✅ All items sufficiently stocked</div>
        ) : (
          <div>
            {lowStock.ingredients.slice(0,5).map(i => (
              <div key={i._id} className="flex justify-between py-1 border-b">
                <span>{i.name}</span>
                <span className="font-semibold text-red-500">{i.quantity} {i.unit}</span>
              </div>
            ))}
            {lowStock.menuItems.slice(0,5).map(i => (
              <div key={i._id} className="flex justify-between py-1 border-b">
                <span>{i.name}</span>
                <span className="font-semibold text-red-500">{i.stock || 0}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Table QR Codes */}
      <div className="bg-white rounded-2xl p-6 shadow">
        <h3 className="text-lg font-bold mb-4 text-gray-700">🧾 Table QR Codes</h3>
        {tableQRCodes.length===0 ? (
          <div className="text-gray-500 text-sm">No tables found.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {tableQRCodes.map((t,i)=>(
              <div key={i} className="p-3 border rounded-lg shadow-sm text-center">
                <h4 className="font-semibold text-gray-700 mb-2">{t.table}</h4>
                <img src={t.qrCode} alt={`QR for ${t.table}`} className="mx-auto w-32 h-32"/>
                <p className="text-xs text-gray-500 mt-2 break-all">{t.url}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Backup Manager */}
      {/* <div className="bg-white rounded-2xl p-6 shadow">
        <h3 className="text-lg font-bold mb-4 text-gray-700">💾 Database Backup Manager</h3>
        <div className="flex gap-3 mb-4">
          <button onClick={handleCreateBackup} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">📦 Create Backup</button>
          <button onClick={loadBackups} className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 transition">🔄 Refresh List</button>
        </div>
        {backups.length===0 ? <div className="text-gray-500">No backups found.</div> :
          <ul className="divide-y divide-gray-200">{backups.map((b,i)=>(
            <li key={i} className="flex justify-between items-center py-2">
              <span className="text-sm text-gray-700">{b.name} {b.createdAt && <span className="text-xs text-gray-500">({new Date(b.createdAt).toLocaleString()})</span>}</span>
              <button onClick={()=>handleRestoreBackup(b.name)} className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition">🔁 Restore</button>
            </li>
          ))}</ul>
        }
      </div> */}
    </div>
  );
}

function RevenueCard({ title, value, highlight }) {
  return (
    <div className={`p-4 rounded-xl shadow text-center transition ${highlight?"bg-green-100 border border-green-300":"bg-white"}`}>
      <div className="text-gray-600 text-sm">{title}</div>
      <div className="text-xl font-bold text-green-700">₹ {Number(value||0).toFixed(2)}</div>
    </div>
  );
}
